var _style, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1614 1291"
    },
    xmlSpace: "preserve",
    viewBox: "652.4 351.1 329.6 342.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83F2FF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M815.8,351.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M800,366.8c-0.1,0.1-0.1,0.1-0.2,0.2l0.2-15.9c-9.8,1.4-20,2.3-29.4,5.4c-0.2-0.1-0.4-0.1-0.6-0.2  c-31.1,4-66.3,31-84.9,55.1c-3.4,4.5-6.6,9.2-9.5,14s-5.5,9.8-7.9,15c-2.4,5.1-4.5,10.4-6.3,15.8s-3.3,10.8-4.5,16.4  c-6.8,31.8-3.9,67.7-3.8,100.1V692c31.6-1.5,64.8-1.2,96.4,0.3c-0.3-32.2,0.4-64.4-0.2-96.6c-16.2-0.4-32.4-0.4-48.5,0.1l0.3,31.7  c10.6-0.5,10.6-0.2,15.9-0.3c0.5,10.7,0.4,21.4,0.1,32.1c-10.5,0.1-21.5-0.4-31.9,0.8L685,559.2c0-27.6-2.7-58.2,4.4-85.1  c1.3-5,3-9.9,5-14.7s4.3-9.5,6.9-14c2.6-4.5,5.5-8.9,8.6-13c3.2-4.2,6.6-8.1,10.2-11.8c13.6-13.7,29.5-23.2,46.9-30.9  c-2.4,29.5-1,59.8-1,89.3v140.3c0,24.8,0.7,49.7-0.1,74.4c11.4-0.7,22.8-0.2,34.2,0.2L800,366.8z M787.9,356.8  c-0.2,0.3-0.3,0.7-0.5,1C787.6,357.5,787.7,357.1,787.9,356.8L787.9,356.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M613.8,331.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M818.5,351.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M834.2,694c11.4-0.4,22.8-0.9,34.2-0.2c-0.8-24.7-0.1-49.6-0.1-74.4V479.1c0-29.5,1.4-59.8-1-89.3  c17.5,7.7,33.4,17.2,46.9,30.9c3.6,3.7,7,7.6,10.2,11.8c3.1,4.1,6,8.5,8.6,13s4.9,9.2,6.9,14s3.7,9.7,5,14.7  c7.1,26.9,4.4,57.5,4.4,85.1l-0.1,100.9c-10.4-1.2-21.4-0.7-31.9-0.8c-0.3-10.7-0.4-21.4,0.1-32.1c5.3,0.1,5.3-0.2,15.9,0.3  l0.3-31.7c-16.1-0.5-32.3-0.5-48.5-0.1c-0.6,32.2,0.1,64.4-0.2,96.6c31.6-1.5,64.8-1.8,96.4-0.3V572.7c0.1-32.4,3-68.3-3.8-100.1  c-1.2-5.5-2.7-10.9-4.5-16.4c-1.8-5.3-3.9-10.6-6.3-15.8c-2.4-5.1-5-10.1-7.9-15s-6.1-9.5-9.5-14c-18.6-24.1-53.8-51.1-84.9-55.1  c-0.2,0.1-0.4,0.1-0.6,0.2c-9.4-3.1-19.6-4-29.4-5.4l0.2,15.9c-0.1-0.1-0.1-0.1-0.2-0.2L834.2,694z M846.4,356.8  c0.2,0.3,0.3,0.7,0.4,1C846.7,357.5,846.5,357.1,846.4,356.8L846.4,356.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1020.5,331.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.dd234bc0a277913dbbd962f6a26ab6dc.svg";
export { ForwardRef as ReactComponent };